import { motion } from 'framer-motion';
import './Pricing.scss';
import { FaCheck } from 'react-icons/fa';

const Pricing = () => {
  return (
    <section className="pricing" id="pricing">
      <section className="sec-pricing">
        <div className="container">
          <motion.div
            className="header"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
  
            <h1 className="title">
              선생님들을 위한 <span className="title-accent">아래한글 기반의</span> 솔루션
            </h1>
            <p className="subtitle">
              <span className="title-accent">독보적인 기술력</span> 매쓰테일러
            </p>
          
          </motion.div>
        </div>
      </section>

      <section className="cards section">
        <div className="container">
          <div className="price-info">
            <h3 className="info-title">가격 정보</h3>
            <p className="info-text">
              합리적인 가격과 무료 AI 기능으로 수학 교육을 지원합니다.
            </p>
            <p className="info-note">* AI 이용 시 aip 계정 필요 (매뉴얼 참고)</p>
            <p className="discontinued-note">
              - BASIC PDF를 HWP 변환 서비스(30원/페이지)는 서비스가 종료되었습니다.
            </p>
          </div>
          
          <div className="pricing-grid">
            {/* PRO 서비스 */}
            <motion.article
              className="card pro-service compact-card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <div className="card-badge pro">PRO</div>
              <div className="card-header">
                <h2 className="card-name">PDF를 HWP로 변환</h2>
              </div>
              <div className="card-price">
                <span className="card-amount">
                  <span className="card-highlight">40원</span>
                </span>
                <span className="card-period">/페이지</span>
              </div>
              <ul className="card-features">
                <li className="card-feature"><FaCheck className="feature-icon" />가입비 0원 · 사용 기간 제한 없음</li>
                <li className="card-feature"><FaCheck className="feature-icon" />빠른 변환 속도 및 고퀄의 결과물</li>
                <li className="card-feature"><FaCheck className="feature-icon" />낙서 시험지 고급 분석</li>
                <li className="card-feature"><FaCheck className="feature-icon" />띄어쓰기 자동 교정</li>
                <li className="card-feature"><FaCheck className="feature-icon" />다단 레이아웃 자동 구분</li>
              </ul>
            </motion.article>

            {/* 문제은행 서비스 */}
            <motion.article
              className="card bank-service compact-card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 }}
            >
              <div className="card-badge bank">문제은행</div>
              <div className="card-header">
                <h2 className="card-name">나만의 문제은행 구축</h2>
              </div>
              <div className="card-price bank-price">
                <span className="card-amount">
                  <span className="card-highlight">20원</span>
                </span>
                <span className="card-period">/문항(문풀답)</span>
              </div>
              <ul className="card-features">
                <li className="card-feature"><FaCheck className="feature-icon" />디비구축 (미주처리된 HWP)</li>
                <li className="card-feature"><FaCheck className="feature-icon" />단원관리 (단원별/학교별)</li>
                <li className="card-feature"><FaCheck className="feature-icon" />문제출제</li>
                <li className="card-feature"><FaCheck className="feature-icon" />출제된 시험지 저장</li>
                <li className="card-feature"><FaCheck className="feature-icon" />프린트 (HWP/PDF)</li>
              </ul>
              <p className="bank-pricing-note">
                자세한 이용 요금은 문제은행 사이트에서 확인해 주세요.
              </p>
            </motion.article>

            {/* 무료 서비스들 */}
            <motion.article
              className="card free-service compact-card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="card-badge free">무료</div>
              <div className="card-header">
                <h2 className="card-name">수학 문제 풀이 AI</h2>
              </div>
              <div className="card-price-free">
                <span className="free-text">FREE</span>
              </div>
              <ul className="card-features">
                <li className="card-feature"><FaCheck className="feature-icon" />수학 문제 정답 및 풀이 생성</li>
                <li className="card-feature"><FaCheck className="feature-icon" />HWP로 변환 가능</li>
              </ul>
            </motion.article>

            <motion.article
              className="card free-service compact-card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <div className="card-badge free">무료</div>
              <div className="card-header">
                <h2 className="card-name">수학 문제 변형 AI</h2>
              </div>
              <div className="card-price-free">
                <span className="free-text">FREE</span>
              </div>
              <ul className="card-features">
                <li className="card-feature"><FaCheck className="feature-icon" />수학 쌍둥이 유사 문제로 변형</li>
                <li className="card-feature"><FaCheck className="feature-icon" />HWP로 변환 가능</li>
              </ul>
            </motion.article>

            <motion.article
              className="card free-service compact-card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <div className="card-badge free">무료</div>
              <div className="card-header">
                <h2 className="card-name">수학 도형 그리기 AI</h2>
              </div>
              <div className="card-price-free">
                <span className="free-text">FREE</span>
              </div>
              <ul className="card-features">
                <li className="card-feature"><FaCheck className="feature-icon" />수학 도형을 고퀄로 새로 그림</li>
                <li className="card-feature"><FaCheck className="feature-icon" />매쓰테일러 그림판을 이용한 보정</li>
              </ul>
            </motion.article>

            <motion.article
              className="card free-service compact-card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              <div className="card-badge free">무료</div>
              <div className="card-header">
                <h2 className="card-name">수학 도형 전용 그림판</h2>
              </div>
              <div className="card-price-free">
                <span className="free-text">FREE</span>
              </div>
              <ul className="card-features">
                <li className="card-feature"><FaCheck className="feature-icon" />쉽고 빠른 수학 도형 그리기</li>
                <li className="card-feature"><FaCheck className="feature-icon" />수학 도형 빠른 복제</li>
              </ul>
            </motion.article>
          </div>
        </div>
      </section>

    </section>
  );
};

export default Pricing;

